var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('front-layout',[_c('v-container',[_c('v-row',{staticClass:"text-center"},[_c('v-col',{attrs:{"cols":"12"}},[_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Home")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }